import { ResourceItem } from "../ResourceItem";

import { createListResource } from "../../list";
import MegaraxClient from "../../megaraxClient";
import { createDetailResource } from "../../detail";
import _ from "lodash";

export class DirectoryPermission extends ResourceItem {
  directory!: string;

  constructor(data?: any) {
    super(data);
    if (data) {
      this.directory = data.directory;
    }
  }

  get key() {
    return "DirectoryPermission" + this.id;
  }
}

export class Permission extends ResourceItem {
  directoryPermissions?: DirectoryPermission[];
  appName!: string;
  serviceName!: string;
  permissionName!: string;

  constructor(data?: any) {
    super(data);
    if (data) {
      if (data.directoryPermissions && data.directoryPermissions.length)
        this.directoryPermissions = data.directoryPermissions.map(
          (d: any) => new DirectoryPermission(d),
        );
      this.appName = data.appName;
      this.serviceName = data.serviceName;
      this.permissionName = data.permissionName;
    }
  }

  get key() {
    return "Permission" + this.id;
  }
}

const apiUrl = "iam/permission/";
export const permissionResource = (client: MegaraxClient) => ({
  ...createListResource(apiUrl, (data) => new Permission(data))(client),
  ...createDetailResource(apiUrl, (data) => new Permission(data))(client),
});

export interface PermissionTree {
  [appName: string]: {
    [serviceName: string]: Permission[];
  };
}

export const permissionListToTree = (
  permissions: Permission[],
): PermissionTree => {
  const tree: PermissionTree = {};
  for (const permission of permissions) {
    const appBranch = tree[permission.appName];
    if (appBranch) {
      const serviceBranch = appBranch[permission.serviceName];
      if (serviceBranch) serviceBranch.push(permission);
      else appBranch[permission.serviceName] = [permission];
    } else
      tree[permission.appName] = {
        [permission.serviceName]: [permission],
      };
  }

  return tree;
};

export interface PermissionApp {
  name: string;
  services: PermissionService[];
}

export interface PermissionService {
  name: string;
  permissions: Permission[];
}

export interface PermissionKeyMap {
  [key: string]: Permission | DirectoryPermission;
}

export const getPermissionKeyMap = (
  list: Permission[],
  exisitingPermissions: Permission[],
  exisitingDirectoryPermissions: DirectoryPermission[],
): PermissionKeyMap => {
  const directoryPermissions = list.flatMap(
    (perm) => perm.directoryPermissions || [],
  );

  return {
    ..._.keyBy(list, "key"),
    ..._.keyBy(directoryPermissions, "key"),
    ..._.keyBy(exisitingPermissions, "key"),
    ..._.keyBy(exisitingDirectoryPermissions, "key"),
  };
};
